import React from 'react';

import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { Modal, ModalTopAction } from 'src/components/common';
import { VerificationRequestPaymentTryAgainModalForm } from 'src/components/verificationRequest';
import { ModalId } from 'src/constants/modals';
import { useScreenInfo } from 'src/hooks/common';
import { useModal } from 'src/hooks/shared';

import { VerificationRequestPaymentTryAgainModalArgs } from './types';

export const VerificationRequestPaymentTryAgainModal: React.FC = () => {
  const { isOpen, closeModal, switchClosability, args } =
    useModal<VerificationRequestPaymentTryAgainModalArgs>(
      ModalId.VerificationRequestPaymentTryAgainModal,
    );

  const { isMobile } = useScreenInfo();

  const mobileTopAction = React.useMemo((): ModalTopAction => {
    return {
      show: true,
      render: () => (
        <IconButton onClick={() => closeModal()}>
          <CloseIcon />
        </IconButton>
      ),
    };
  }, [closeModal]);

  if (!args?.inboxItemId) {
    return null;
  }

  return (
    <Modal
      title="Payment Issue"
      headerPadding="24px 32px 16px"
      topAction={isMobile ? mobileTopAction : undefined}
      dialogProps={{
        onClose: () => closeModal(),
        open: isOpen,
        fullScreen: isMobile,
      }}
    >
      <VerificationRequestPaymentTryAgainModalForm
        closeModal={closeModal}
        switchClosability={switchClosability}
        inboxItemId={args.inboxItemId}
      />
    </Modal>
  );
};
